import {
  ActionValidation,
  ArrayValidation,
  BooleanValidation,
  ObjectValidation,
  StringValidation,
} from '../../../../../utils/component-validations';
import { action } from '@ember/object';
import { fn } from '@ember/helper';
import { on } from '@ember/modifier';
import { tracked } from '@glimmer/tracking';
import Button from '../../../core/button.gjs';
import FlexRow from '../../../layout/flex/row.gjs';
import MultiselectClearFilter from '../../../core/multiselect-clear-filter.gjs';
import Super from '../../../core/base.gjs';
import shiftFocusToParent from '../../../../../modifiers/shift-focus-to-parent';
import styles from './trigger.module.scss';
import svgJar from 'ember-svg-jar/helpers/svg-jar';

export default class SpdsInputDropdownListTrigger extends Super {
  arguments = [
    new ActionValidation({ required: ['onClose'] }),
    new BooleanValidation({
      optional: ['autofocus', 'disabled', 'error', 'multiselect'],
      required: ['open'],
    }),
    new StringValidation({ optional: ['placeholder'], required: ['triggerId'] }),
  ];
  baseClass = 'spds-input-dropdown-list-trigger-container';
  classesToMapToArgs = ['disabled', 'error', 'open'];
  elementsToRegister = [{ name: 'trigger', selector: 'button' }];
  styles = styles;

  @tracked clearFilterComponent;

  get buttonClasses() {
    let classes = ['spds-input-dropdown-list-trigger'];

    if (this.hasMultiselectOptions || this.hasSelectedOption) classes.push('active');

    return classes.join(' ');
  }

  get hasMultiselectOptions() {
    let { multiselect, selected } = this.args;

    return multiselect && selected?.length > 0;
  }

  get hasSelectedOption() {
    let { multiselect, selected } = this.args;

    return !multiselect && selected;
  }

  get text() {
    let { placeholder, selected } = this.args;

    if (this.hasMultiselectOptions) return '';

    return selected && !Array.isArray(selected) ? selected?.textContent.trim() : placeholder;
  }

  constructor() {
    super(...arguments);

    if (this.args.multiselect) {
      this.arguments.push(new ArrayValidation({ optional: ['selected'] }));
    } else {
      this.arguments.push(new ObjectValidation({ optional: ['selected'] }));
    }
  }

  @action
  clearSelection(value, evt) {
    evt.stopPropagation();
    evt.target.classList.remove('active');

    this.args.clearSelection(...arguments);
  }

  <template>
    <FlexRow
      class={{this.classes}}
      data-test-spds-input-dropdown-list-trigger-container
      {{this.setupComponent}}
      {{this.validateArguments}}
    >
      <Button
        @autofocus={{@autofocus}}
        aria-controls={{@menuId}}
        class={{this.buttonClasses}}
        data-test-spds-input-dropdown-list-trigger
        disabled={{@disabled}}
        id={{@triggerId}}
        {{on "click" @onClick}}
        {{shiftFocusToParent}}
        ...attributes
      >
        <FlexRow @tag="span" class="spds-input-dropdown-list-trigger-text-container">
          {{this.text}}
        </FlexRow>
        {{svgJar "dropdown-caret" class="spds-input-dropdown-list-trigger-caret"}}
      </Button>
      {{#if @multiselect}}
        <MultiselectClearFilter
          @disabled={{@disabled}}
          @clearSelection={{@clearSelection}}
          @registerComponent={{fn this.registerComponent "clearFilterComponent"}}
          @selected={{@selected}}
          @unregisterComponent={{fn this.unregisterComponent "clearFilterComponent"}}
        />
      {{/if}}
    </FlexRow>
  </template>
}
